import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => {
  const { marginLR, paddingLR } = theme.mixins;
  return {
    listingLayoutWrappeer: {
      paddingTop: pxToRem(48),
      paddingBottom: pxToRem(48),
      ...paddingLR(theme.spacing(3), theme.spacing(3)),
      // background: theme.mixins.milkWhite(200),
      background: theme.mixins.White(),
      minHeight: '60vh',

      [theme.breakpoints.up('lg')]: {
        display: 'flex',
        padding: `${theme.spacing(11)} 5.5%`,
        margin: 0,
      },
    },
    filterSection: {
      [theme.breakpoints.up('lg')]: {
        flexBasis: '25%',
        position: 'relative',
        zIndex: 1,
      },
      [theme.breakpoints.down('lg')]: {
        '& section': {
          transform: 'none',
        },
      },
    },
    smartList: {
      [theme.breakpoints.up('lg')]: {
        flexBasis: '75%',
        ...marginLR(pxToRem(24), 0),
      },
      '& :last-child .smart-list-wrapper': {
        marginBottom: '0',
      },
    },
    filterdList: {
      overflowAnchor: 'none',
      [theme.breakpoints.up('lg')]: {
        flexBasis: '75%',
        ...marginLR(pxToRem(24), 0),
      },
    },
  };
});

export default useStyles;
